import styled from 'styled-components';

export const SliderImagesWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  overflow: hidden;
`;

export const ImagesWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const SliderImgWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  &:not(:first-child) {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }
`;

export const SliderImg = styled.img`
  height: auto;
  display: block;
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  max-width: 650px;

  /* Mobile default - 559 */
  @media (min-width: 0px) and (max-width: 559px) {
    max-width: 200px;
  }

  /* Mobile 560 - 960 */
  @media (min-width: 560px) and (max-width: 959px) {
    max-width: 375px;
  }

  /* Tablet 960 - 1279 */
  @media (min-width: 960px) and (max-width: 1279px) {
    max-width: 500px;
  }
`;
